<template>
  <div>
    <div class="sixteentosix sixteentosix-wrap omt-6 omt-md-25">
      <div class="new-background-wrap">
        <div
          class="kachelimage header-image zoom-image"
          style="background: url('/static/img/default_header.png')"
        ></div>
        <div>
          <div
            class="kachelimage header-image zoom-image"
            style="background: url('/static/img/default_header.png')"
          ></div>
        </div>
        <div class="headline-wrap">
          <div class="headline">
            <div class="text-subtitle-2 text-md-h5">
              <img
                class="ml-2"
                src="../assets/img/arrow_right.svg"
                height="18px"
              /><img
                class="mr-2"
                src="../assets/img/arrow_right.svg"
                height="18px"
              />
            </div>
          </div>
        </div>
        <div class="headline-wrap">
          <div class="headline">
            <div class="text-subtitle-2 text-md-h5">
              {{ $t("training_event_categorys") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb
      :trainingNameEdit="categoryNameBreadCrumb"
      :showEventTab="$user != null && $rights.includes('VIEW_TRAINING_EVENT')"
    />
    <div>
      <div class="row align-items-start">
        <!-- Left Area -->
        <div class="col-xl-9 px-0" v-if="eventTrainingCategory">
          <div class="pl-12 pl-md-16 mx-0 pa-0 text-content tcd_page">
            <h1>
              {{ eventTrainingCategory.designationsMap[$locale.toLowerCase()] }}
              :
            </h1>
            <div
              v-if="
                eventTrainingCategory &&
                eventTrainingCategory.goalsMap &&
                eventTrainingCategory.goalsMap[$locale]
                  ? eventTrainingCategory.goalsMap[$locale]
                  : ''
              "
            >
              <h4>{{ $t("training_goals") }}</h4>
              <p
                v-html="
                  eventTrainingCategory &&
                  eventTrainingCategory.goalsMap &&
                  eventTrainingCategory.goalsMap[$locale]
                    ? eventTrainingCategory.goalsMap[$locale]
                    : ''
                "
              ></p>
              <div class="mt-10"></div>
            </div>
            <div
              v-if="
                eventTrainingCategory &&
                eventTrainingCategory.targetGroupsMap &&
                eventTrainingCategory.targetGroupsMap[$locale]
                  ? eventTrainingCategory.targetGroupsMap[$locale]
                  : ''
              "
            >
              <h4>{{ $t("target_group") }}</h4>
              <p
                v-html="
                  eventTrainingCategory &&
                  eventTrainingCategory.targetGroupsMap &&
                  eventTrainingCategory.targetGroupsMap[$locale]
                    ? eventTrainingCategory.targetGroupsMap[$locale]
                    : ''
                "
              ></p>
              <div class="mt-10"></div>
            </div>

            <div
              v-if="
                eventTrainingCategory &&
                eventTrainingCategory.descriptionsMap &&
                eventTrainingCategory.descriptionsMap[$locale]
                  ? eventTrainingCategory.descriptionsMap[$locale]
                  : ''
              "
            >
              <h4>{{ $t("training_content") }}</h4>
              <p
                v-html="
                  eventTrainingCategory &&
                  eventTrainingCategory.descriptionsMap &&
                  eventTrainingCategory.descriptionsMap[$locale]
                    ? eventTrainingCategory.descriptionsMap[$locale]
                    : ''
                "
              ></p>
              <div class="mt-10"></div>
            </div>

            <div
              v-if="
                eventTrainingCategory &&
                eventTrainingCategory.prerequesitesMap &&
                eventTrainingCategory.prerequesitesMap[$locale]
                  ? eventTrainingCategory.prerequesitesMap[$locale]
                  : ''
              "
            >
              <h4>{{ $t("prerequesites") }}</h4>
              <p
                v-html="
                  eventTrainingCategory &&
                  eventTrainingCategory.prerequesitesMap &&
                  eventTrainingCategory.prerequesitesMap[$locale]
                    ? eventTrainingCategory.prerequesitesMap[$locale]
                    : ''
                "
              ></p>
              <div class="mt-10"></div>
            </div>
            <h4>{{ $t("further_information") }}</h4>
            <p class="further_information_text">
              <b>{{ $t("location") }}:</b>
              {{ eventTrainingCategory.possibleLocations }}
            </p>
            <p class="further_information_text">
              <b>{{ $t("event_training_category_type") }}:</b>
              {{ $t(eventTrainingCategory.type) }}
            </p>
            <p class="further_information_text">
              <b>{{ $t("training_duration") }}:</b>
              {{ $t(eventTrainingCategory.durationInDays) }}
              {{
                $t(
                  eventTrainingCategory.durationInDays === "1"
                    ? $t("day")
                    : $t("days")
                )
              }}
            </p>
            <p class="further_information_text">
              <b>{{ $t("price") }}:</b>&nbsp;<span
                v-show="eventTrainingCategory.priceFormatted == null"
                >{{ $t("by_request") }}</span
              ><span v-show="eventTrainingCategory.priceFormatted != null"
                >{{ eventTrainingCategory.priceFormatted }}€</span
              >
            </p>
          </div>
          <div class="mt-14 mx-0 pa-0 text-content sa_us">
            <h4 class="pl-12 sapl-md-16 pb-2">{{ $t("upcoming_events") }}</h4>
            <div class="row mx-5 ml-md-12" v-if="events.length > 0">
              <div
                class="event-tile custom-event-tile p-0 my-5 samy-5 col-xl-4"
                v-for="event in events"
                :key="event.id"
                @click="eventClicked(event)"
              >
                <div
                  class="border border_theme mb-0 pt-5 pl-5 pr-5 pb-5 ml-2 mr-2"
                >
                  <div class="event-background-image"></div>
                  <h4 class="font-weight-bold font-grey">
                    {{ event.startDateFormatted }}
                  </h4>
                  <p class="mb-6">{{ event.timesFormatted }}</p>
                  <p class="font-weight-bold mb-0">
                    {{ event.room.location.designation }}
                  </p>
                  <p class="mb-6 se_height">{{ event.room.designation }}</p>
                  <p class="mb-6 se_height">{{ $t(event.eventType) }}</p>
                  <p class="mb-3 se_height">
                    {{ $t("language") }} - {{ $t(event.language) }}
                  </p>
                  <p
                    style="color: var(--blue)"
                    class="pb-0 mb-2 font-weight-bold text-uppercase"
                  >
                    {{ $t("availableSeats") }}
                    <span style="font-size: 18px"> {{ event.freeSpaces }}</span>
                    {{ $t("of") }}
                    <span style="font-size: 18px">{{
                      event.maxParticipants
                    }}</span>
                  </p>
                  <div style="" class="bg-blue py-1 pr-7 pl-7 sa-wd">
                    {{ $t("take_part_now") }}
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="row mx-5 ml-md-12 border border-1">
              {{ $t("no_upcoming_events") }}
            </div>
          </div>
        </div>
        <!-- Right Area -->
        <div class="col-xl-3 pl-12 pl-md-16 row">
          <div
            class="col-xl-12 right-side-block"
            v-if="
              $user == null ||
              ($user && $rights.includes('CREATE_TRAINING_REQUEST'))
            "
          >
            <h4 class="text-uppercase">{{ $t("actions") }}</h4>
            <div class="right-side divider"></div>
            <div class="mt-6"></div>
            
            <v-btn
              @click="$routerBack()"
              outlined
              depressed
              tile
              class="backbutton mr-2 mb-2"
            >
              <v-icon>mdi-chevron-left</v-icon> {{ $t("back") }}</v-btn
            >
            <v-btn
              v-if="
                $user == null ||
                ($user && $rights.includes('CREATE_TRAINING_REQUEST'))
              "
              @click="bookingRequestClicked()"
              outlined
              depressed
              tile
              class="savebutton mr-2 mb-2"
              >{{ $t("booking_request") }}</v-btn
            >
          </div>
          <Contact />
          <Share
            :headline="$t('share_training')"
            :mailSubject="
              $t('share_mail_subject', {
                name: eventTrainingCategory.designationsMap[$locale],
              })
            "
            :mailText="getShareMailText()"
          />
        </div>
      </div>

      <!-- Dialogs -->
      <v-dialog v-model="openRequestQuestionDialog">
        <div class="mx-0 pa-0 text-content sa_us">
          <h4 class="ml-2">{{ $t("have_you_seen_our_events") }}</h4>
          <div class="row ml-0 mr-0 mt-4">
            <div
              class="event-tile custom-event-tile p-0 my-5 samy-5 col-xl-4"
              v-for="event in events"
              :key="event.id"
              @click="eventClicked(event)"
            >
              <div
                class="border border_theme mb-0 pt-5 pl-5 pr-5 pb-5 ml-2 mr-2"
              >
                <div class="event-background-image"></div>
                <h4 class="font-weight-bold font-grey">
                  {{ event.startDateFormatted }}
                </h4>
                <p class="mb-6">{{ event.timesFormatted }}</p>
                <p class="font-weight-bold mb-0">
                  {{ event.room.location.designation }}
                </p>
                <p class="mb-6">{{ event.room.designation }}</p>
                <p
                  style="color: var(--blue)"
                  class="pb-0 mb-2 font-weight-bold text-uppercase"
                >
                  {{ $t("availableSeats") }}
                  <span style="font-size: 18px"> {{ event.freeSpaces }}</span>
                  of
                  <span style="font-size: 18px">{{
                    event.maxParticipants
                  }}</span>
                </p>
                <div style="" class="bg-blue py-1 pr-7 pl-7 sa-wd">
                  {{ $t("take_part_now") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="openRequestQuestionDialog = false"
            outlined
            depressed
            tile
            class="cancelbutton mr-2 mb-2"
          >
            {{ $t("cancel") }}</v-btn
          >
          <v-btn
            :to="bookingRequestUrl"
            outlined
            depressed
            tile
            class="savebutton mr-2 mb-2"
            >{{ $t("custom_request") }}</v-btn
          >
        </v-card-actions>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "./Breadcrumbs.vue";
export default {
  props: {
    // catgoryId:Number,
  },
  components: {
    Breadcrumb,
  },

  data() {
    return {
      categoryNameBreadCrumb: "",
      categoryId: null,
      eventTrainingCategory: null,
      training: null,
      events: [],
      openRequestQuestionDialog: false,

      routes: {
        training: "/api/training/url/",
        events: "/api/training/event/eventtraining/id/",
        location: "/api/location/",
      },
    };
  },

  watch: {},

  computed: {
    bookingRequestUrl: {
      get: function () {
        if (this.eventTrainingCategory == null) return "/request";
        return (
          "/request?eventTrainingCategoryId=" + this.eventTrainingCategory.id
        );
      },
    },
  },

  mounted() {
    this.categoryId = window.location.href.substring(
      window.location.href.lastIndexOf("/") + 1
    );
    if (this.$route.query.categoryId) {
      this.categoryId = this.$route.query.categoryId;
      this.fetchTrainingEventCategory(this.$route.query.categoryId);
    }
  },

  methods: {
    onError(err) {
      if (
        err.response != null &&
        err.response.data != null &&
        err.response.data.message != null
      ) {
        this.$noty.error(err.response.data.message);
      } else {
        console.error(err);
      }
    },

    fetchTrainingEventCategory() {
      var _this = this;
      this.$axios
        .get("/api/eventTrainingCategory/" + this.categoryId)
        .then(function (response) {
          _this.eventTrainingCategory = response.data;
          _this.fetchEventsForTraining();
          _this.categoryNameBreadCrumb =
            _this.eventTrainingCategory.designationsMap[
              _this.$locale.toLowerCase()
            ];
        })
        .catch(this.onError);
    },
    fetchEventsForTraining() {
      var _this = this;

      this.$axios
        .get(this.routes.events + this.eventTrainingCategory.id)
        .then(function (response) {
          _this.events = response.data.filter(
            (event) => event.freeSpaces !== 0
          );
          for (let i = 0; i < _this.events.length; i++) {
            const event = _this.events[i];
            if (event.room !== null && typeof event.room.location == "number") {
              _this.$axios
                .get(_this.routes.location + event.room.location)
                .then(function (response) {
                  event.room.location = response.data;
                })
                .catch(_this.onError);
            } else if (event.room === null) {
              event.room = {};
              event.room.location = {};
              event.room.designation = "";
              event.room.location.designation = _this.$t("virtual");
            }
          }
        })
        .catch(this.onError);
    },

    bookingRequestClicked() {
      if (
        this.events.length > 0 &&
        this.eventTrainingCategory.showUpcomingSchedules
      ) {
        this.openRequestQuestionDialog = true;
        return;
      }
      this.$router.push(this.bookingRequestUrl);
    },

    eventClicked(event) {
      if (this.$user == null) {
        // Not logged in
        this.$router.push(
          "/login?routingTarget=/edit-training-event?trainingEventId=" +
            event.id
        );
        return;
      } else if (this.$user && this.$rights.includes("VIEW_TRAINING_EVENT")) {
        this.$router.push("/edit-training-event?trainingEventId=" + event.id);
      }
      return false;
    },

    getShareMailText() {
      return this.$t("share_mail_content", { link: window.location.href });
    },
  },
};
</script>
